import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import LandingPage from './components/LandingPage';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import PublicView from './components/PublicView';

function PrivateRoute({ children }) {
  const { currentUser, userProfile, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div className="loading-spinner-lg" />
      </div>
    );
  }
  if (!currentUser || !userProfile) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function AuthRoute() {
  const { currentUser, userProfile, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div className="loading-spinner-lg" />
      </div>
    );
  }
  if (currentUser && userProfile) {
    return <Navigate to="/dashboard" replace />;
  }
  return <LoginPage />;
}

function LandingRoute() {
  const { currentUser, userProfile, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div className="loading-spinner-lg" />
      </div>
    );
  }
  if (currentUser && userProfile) {
    return <Navigate to="/dashboard" replace />;
  }
  return <LandingPage />;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/" element={<LandingRoute />} />
            <Route path="/login" element={<AuthRoute />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route path="/:username" element={<PublicView />} />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
